{
	"main": {
		"titleAktivnosti": "TODAY'S AIR ACTIVITIES",
		"subtitleAktivnosti": "ACTIVITIES ON SELECTED DATE"
	},
	"labels": {
		"datum": "Activity date:"
	},
	"aktivnosti": {
		"title": "Activity overview for date",
		"opozorila": "WARNINGS",
		"cas": "Time:",
		"vnesel": "Entered:",
		"mainTitle": "FLIGHT SCHEDULE"
	},
	"razpored": {
		"titleJ": "Gliders",
		"titleM": "Powered aircraft",
		"titleUL": "UltraLight aircraft",
		"let": "Flight",
		"planirano": "Planned:",
		"naloga": "Task:",
		"sredstvo": "Means:",
		"vrstaLetala": "Aircraft type:",
		"izvrsilec": "Aircraft inspection executor:",
		"podpis": "Signature:"
	},
	"obvestila": {
	  "brisiSredstvo": "Are you sure you want to delete the asset?",
	  "vnosUspesen": "Entry successful",
	  "vnosNeuspesen": "Error retrieving data.",
	  "nepricakovanaNapaka": "An unexpected error occurred",
	  "poslano": "Message sent",
	  "niPoslano": "Message was not sent"
	}
}